import React from 'react';
import "../style/AppPages.css"
import { Trans, useTranslation } from 'react-i18next';

const TermsOfService = () => {
    const { t } = useTranslation();

    return (
        <div class="page-padding-info">
            <div class="text-page-container">
            <h1 class="text-page-title">Terms of Services</h1>

            <strong>{t("privacyPolicy.introTitle")}</strong>
            <p>
                    {t("termsOfSale.welcome")} 
                    <br></br>
                    {t("termsService.intro1")}
                    <br></br>
                    <br></br>
                    {t("termsService.intro2")}
                    <br></br>
                    <br></br>
                    <Trans i18nKey="termsService.intro3" components={{ 1: <a href="mailto:contact@awootoys.com" /> }} />
                    <br></br>
                    <br></br>
                    {t("termsService.intro4")}
                    <br></br>
                    <br></br>
                    {t("termsService.intro5")}
                </p>

                <strong>{t("termsOfSale.definitionTitle")} </strong>
                <div style={{ marginLeft: "2rem" }}>
                    <ul>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.usTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsService.usText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.serviceTitle")} :
                                </strong>
                                &nbsp;
                                {t("termsService.serviceText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.websiteTitle")} :
                                </strong>
                                &nbsp;
                                <Trans i18nKey="termsService.websiteText" components={{ 1: <strong />, 2: <u />, 3: <a href="https://www.awootoys.com" class="no-link-color"/>  }} />
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.userTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsService.userText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.systemTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsService.systemText")}
                            </p>
                        </li>
                        <li>
                            <p>
                                <strong>
                                    {t("termsService.contentTitle")} : 
                                </strong>
                                &nbsp;
                                {t("termsService.contentText")}
                            </p>
                        </li>
                    </ul>
                </div>

                <br />

                <strong>{t("termsService.purchasingTitle")}</strong>
                <p>
                {t("termsService.purchasingText1")}
                </p>
                <p>
                {t("termsService.purchasingText2")}
                </p>
                <p>
                <Trans i18nKey="termsService.purchasingText3" components={{ 1: <br />  }}/>
                </p>

                <strong>{t("termsService.userAccountTitle")}</strong>
                <p>
                {t("termsService.userAccountText1")}
                </p>
                <p>
                {t("termsService.userAccountText2")}
                </p>
                <p>
                {t("termsService.userAccountText3")}
                </p>

                <strong>{t("termsService.protectionTitle")}</strong>
                <p>
                {t("termsService.protectionText1")}
                </p>
                <p>
                {t("termsService.protectionText2")}
                </p>
                <p>
                    <Trans  i18nKey="termsService.protectionText3" components={{ 1: <a href="mailto:contact@awootoys.com" />, 2: <strong />, 3: <a href="/privacy-policy" class="no-link-color" />  }}/>
                </p>

                <strong>{t("termsService.pricingTitle")}</strong>
                <p>
                {t("termsService.pricingText1")}
                </p>
                <p>
                {t("termsService.pricingText2")}
                </p>
                <p>
                {t("termsService.pricingText3")}
                </p>

                <strong>{t("termsService.paymentTitle")}</strong>
                <p>
                {t("termsService.paymentText")}
                </p>

                <strong>{t("termsService.shippingDeliveryTitle")}</strong>
                <p>
                {t("termsService.shippingDeliveryText1")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText2")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText3")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText4")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText5")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText6")}
                </p>
                <p>
                {t("termsService.shippingDeliveryText7")}
                </p>

                <strong>{t("termsService.intelPropertyTitle")}</strong>
                <p>
                {t("termsService.intelPropertyText1")}
                </p>
                <p>
                {t("termsService.intelPropertyText2")}
                </p>
                <p>
                {t("termsService.intelPropertyText3")}
                </p>

                <strong>{t("termsService.liabilityTitle")}</strong>
                <br></br>
                <br></br>
                <b>{t("termsService.liabilityText")}</b>
                <br></br>
                <br></br>

                <strong>{t("termsService.governingTitle")}</strong>
                <p>
                {t("termsService.governingText")}
                </p>

                <strong>{t("privacyPolicy.ourAddressTitle")}</strong>
                <p>
                {t("termsService.contactText")}
                </p>
                <p>
                    <a href="mailto:contact@awootoys.com">Contact@awootoys.com</a>
                    <br></br>
                    <strong>Awootoys</strong>
                    <br></br>
                    Quebec City, Quebec
                    <br></br>
                    Canada
                </p>
            </div>
        </div>
    );
}

export default TermsOfService;